// @ts-nocheck
const getProductPricingItems = ({
  rrpPrice,
  salePrice,
  villagePrice,
  labels = {},
}) => {
  if (rrpPrice && villagePrice && salePrice) {
    return [
      {
        price: salePrice,
        strikethrough: false,
        label: labels.salePriceLabel || '',
      },
      {
        price: villagePrice,
        strikethrough: true,
        label: labels.villagePriceLabel || '',
      },
      {
        price: rrpPrice,
        strikethrough: true,
        label: labels.rrpPriceLabel || '',
      },
    ]
    // eslint-disable-next-line no-else-return
  } else if (rrpPrice && villagePrice && !salePrice) {
    return [
      {
        price: villagePrice,
        strikethrough: false,
        label: labels.villagePriceLabel || '',
      },
      {
        price: rrpPrice,
        strikethrough: true,
        label: labels.rrpPriceLabel || '',
      },
    ]
  } else if (rrpPrice && !villagePrice && salePrice) {
    return [
      {
        price: salePrice,
        strikethrough: false,
        label: labels.salePriceLabel || '',
      },
      {
        price: rrpPrice,
        strikethrough: true,
        label: labels.rrpPriceLabel || '',
      },
    ]
  } else if (!rrpPrice && villagePrice && salePrice) {
    return [
      {
        price: salePrice,
        strikethrough: false,
        label: labels.salePriceLabel || '',
      },
      {
        price: villagePrice,
        strikethrough: true,
        label: labels.villagePriceLabel || '',
      },
    ]
  } else if (rrpPrice && !villagePrice && !salePrice) {
    return [
      {
        price: rrpPrice,
        strikethrough: false,
        label: labels.rrpPriceLabel || '',
      },
    ]
  } else if (!rrpPrice && villagePrice && !salePrice) {
    return [
      {
        price: villagePrice,
        strikethrough: false,
        label: labels.villagePriceLabel || '',
      },
    ]
  } else if (!rrpPrice && !villagePrice && salePrice) {
    return [
      {
        price: salePrice,
        strikethrough: false,
        label: labels.salePriceLabel || '',
      },
    ]
  }

  return []
}

export default getProductPricingItems
